import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import APIHelper from 'web-app/services/api-helper';

import {type ForgotPasswordFormData, type ExistingLogin} from './models';

export const fetchDeviceAccounts = (deviceId: string) => {
    const overrideApiKey = APIHelper.loginsAPIKey;
    return RESTClient.getObservable(`v2/devices/${deviceId}/logins`, undefined, {
        overrideApiKey,
    }).map(response => {
        if (response.length === 0) {
            APIHelper.clearAPIConfig();
        } else {
            APIHelper.setApiConfig(overrideApiKey);
        }
        return response;
    });
};

export const removeAccount = (deviceId: string, loginId: string) => {
    return RESTClient.postObservable(`v2/devices/${deviceId}/logins/${loginId}`, {
        delete: 1,
    });
};

export const forgotPassword = (data: ForgotPasswordFormData, apiKey?: string) => {
    return RESTClient.post('login/login/forgotpassword', data, apiKey ? {overrideApiKey: apiKey} : undefined);
};

export const loginsExists = (email: string) => {
    return RESTClient.postObservable(`v2/logins/exists`, {
        email,
    }).map((logins: ExistingLogin[]) => List(logins));
};

export const getLocale = () => RESTClient.getObservable('v2/locale', {}).map(response => response.locale);
